import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {take, tap} from 'rxjs/operators';
import {UrlProviderService} from '../../../../../shared/services/general';
import {PathologyReportStatus, PathologyResult} from '../../models/results';
import {OrdersService} from '../../../../shared/services/orders.service';

@Component({
  selector: 'app-pathology-results',
  templateUrl: './pathology-results.component.html',
  styleUrls: ['./pathology-results.component.scss'],
})
export class PathologyResultsComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() public orderId: number = -1;
  @Input() public isCancelled: boolean = false;
  public isLoading = false;
  public results: PathologyResult[] = [];

  constructor(
    private orderService: OrdersService,
    private urlProvider: UrlProviderService,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private sanitizer: DomSanitizer,
  ) {
  }

  public ngOnInit() {
    this.isLoading = true;
  }

  public ngAfterViewInit(): void {
    this.isLoading = true;

    this.orderService.getPathologyResults(this.orderId)
      .pipe(
        take(1),
        tap(results => {
            const aux: any[] = [];
            results.forEach(result => {
              if (result.results) {
                result.results.forEach(r => {
                  switch (r.status) {
                    case PathologyReportStatus.NormalRelease:
                      r.title = 'Result Report';
                      r.comment = this.sanitize(r.comment as string);
                      break;
                    case PathologyReportStatus.AddendumRelease:
                      const countAddendum = aux.filter(y => y.status === PathologyReportStatus.AddendumRelease).length;
                      r.title = 'Addendum ' + (countAddendum + 1);
                      r.comment = this.sanitize(r.comment as string);
                      break;
                    case PathologyReportStatus.RevicedRelease:
                      const countRevision = aux.filter(y => y.status === PathologyReportStatus.RevicedRelease).length;
                      r.title = 'Revision ' + (countRevision + 1);
                      r.comment = this.sanitize(r.comment as string);
                      break;
                  }
                });
              }
            });
          },
        ),
      )
      .subscribe(results => {
        this.results = results;
        this.isLoading = false;
      });
  }

  public forTracker(index: number, result: any) {
    return result;
  }

  public sanitize(html: string) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.orderId.currentValue) {
      this.isLoading = true;
      this.orderService.getPathologyResults(changes.orderId.currentValue)
        .pipe(
          take(1),
          tap(results => {
              const aux: any[] = [];
              results.forEach(result => {
                if (result.results) {
                  result.results.forEach(r => {
                    switch (r.status) {
                      case PathologyReportStatus.NormalRelease:
                        r.title = 'Result Report';
                        r.comment = this.sanitize(r.comment as string);
                        break;
                      case PathologyReportStatus.AddendumRelease:
                        const countAddendum = aux.filter(y => y.status === PathologyReportStatus.AddendumRelease).length;
                        r.title = 'Addendum ' + (countAddendum + 1);
                        r.comment = this.sanitize(r.comment as string);
                        break;
                      case PathologyReportStatus.RevicedRelease:
                        const countRevision = aux.filter(y => y.status === PathologyReportStatus.RevicedRelease).length;
                        r.title = 'Revision ' + (countRevision + 1);
                        r.comment = this.sanitize(r.comment as string);
                        break;
                    }
                  });
                }
              });
            },
          ),
        )
        .subscribe(results => {
          this.results = results;
          this.isLoading = false;
        });
    }
  }
}
